export enum TraCuuThongTinQuyHoachActionType {
  SetSoToSoThua = 'TCTTQH_SetSoToSoThua',
  SetToaDo = 'TCTTQH_SetToaDo',
  SetKetQua='TCTTQH_SetKetQua'
}